module.exports = __webpack_public_path__ + "media/MRI7B.ede24f8a.mp3";